import React from "react";
import "./Contactuspage.css";
import axios from "axios";
import { emailValidation } from "../../assets/utils/constFuntion";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

class DemoContact extends React.Component {
  state = {
    name: "",
    phone: "",
    mobilenumber: "",
    emailid: "",
    industrytype: "",
    i_agree: "false",
    firstNameError: false,
    mobileNumberError: false,
    industryTypeError: false,
    emailError: false,
    countryCode: "in",
  };

  checkflag = false;
  flag = 0;
  datasend = false;

  componentDidMount() {
    // axios
    //   .get(`http://ip-api.com/json`)
    //   .then((response) =>
    //     this.setState({ countryCode: response.data.countryCode.toLowerCase() })
    //   );
  }

  postdatahandler = (e) => {
    e.preventDefault();

    if (!this.handleFullName()) {
      return false;
    }
    if (!this.handleEmail()) {
      return false;
    }
    if (!this.handleMobileNumber()) {
      return false;
    }
    if (!this.handleIndustry()) {
      return false;
    }
    if (!this.state.i_agree) {
      this.setState({
        isAgreeError: true,
      });
      return false;
    } else {
      this.setState({
        isAgreeError: false,
      });
    }
    // var emailid = this.state.emailid;
    // var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    // console.log("======>>>>>>>", pattern.test(emailid));
    // var validemail = pattern.test(emailid);

    // var name = this.state.name;
    // console.log("length f name", name.length);
    // var patternm = /^[a-zA-Z][\sa-zA-Z]*/;
    // var validname = patternm.test(name);

    // var patternmm = /^[A-Za-z0-9 ]+$/;
    // var validnamee = patternmm.test(name);

    const data = {
      full_name: this.state.name,
      email_id: this.state.emailid,
      mobile_no: this.state.phone,
      industry_type: this.state.industrytype,
      form_type: "ContactUs",
      i_agree: "true",
    };

    console.log(data);
    console.log("checkflag", this.checkflag);
    console.log("state-i_agree", this.state.i_agree);
    if (
      this.state.name === "" ||
      this.state.phone === "" ||
      this.state.emailid === ""
    ) {
      this.datasend = false;
    } else {
      this.datasend = true;
    }
    if (this.state.i_agree === true) {
      console.log("data send");
      this.checkflag = true;

      document.getElementById("submitbtn4").style.display = "none";
      //document.getElementById("spinner1").style.visibility = "visible";
      document.getElementById("spinner1").style.display = "block";

      // document.getElementById("submitbtn4").style.backgroundColor = 'red';
      axios
        .post(
          "https://www.avantgardepayments.com/agadmin/api/emailSender/post",
          data
        )
        .then((response) => {
          console.log(response);
          this.datasend = false;

          if (response.data.message === "Success") {
            //document.getElementById("spinner1").style.visibility = "hidden";
            document.getElementById("spinner1").style.display = "none";
            document.getElementById("submitbtn4").style.display = "inline";
            document.getElementById("submitbtn4").style.backgroundColor =
              "var(--darkgreen)";
            document.getElementById("submitbtn4").innerHTML = "Send";
            // document.getElementById("confmsg1").style.visibility = "visible";
            document.getElementById("confmsg1").style.display = "block";
            window.location.href = "/demo-thankyou";
          }

          if (response.data.message === "Success") {
            setTimeout(function () {
              document.getElementById("submitbtn4").style.backgroundColor =
                "var(--lightblue)";
              document.getElementById("submitbtn4").innerHTML = "Submit";
              //document.getElementById("confmsg1").style.visibility = "hidden";
              document.getElementById("confmsg1").style.display = "none";
            }, 5000);
          }

          if (response.data.message === "Success") {
            if (this.checkflag) {
              document.getElementById("txtFirstName3").value = "";
              document.getElementById("txtEmail3").value = "";
              document.getElementById("txtMobile3").value = "";
              document.getElementById("chkAgreeTC3").checked = false;
              document.getElementById("txtIndustryType3").selectedIndex = 0;
              this.flag = this.flag + 1;
              if (this.flag % 2 === 0) {
                this.setState({
                  i_agree: false,
                });
              } else {
                this.setState({
                  i_agree: true,
                });
              }
              this.checkflag = false;
            }
          }

          if ((response.data.message = "Success")) {
            setTimeout(function () {
              document.getElementById("fullform").classList.add("close2");
              document.getElementById("backdrop").classList.add("close2");
            }, 4000);
          }
        }); //end

      setTimeout(function () {
        document.getElementById("submitbtn4").style.backgroundColor =
          "var(--lightblue)";
        document.getElementById("submitbtn4").innerHTML = "Submit";
        //document.getElementById("confmsg1").style.visibility = "hidden";
        document.getElementById("confmsg1").style.display = "none";
      }, 2000);
    }
    // };

    /* setTimeout(function(){ document.getElementById("submitbtn4").style.backgroundColor = 'var(--lightblue)';
                               document.getElementById("submitbtn4").innerHTML = "Submit"; }, 5000);*/

    // axios.post('www.avantgardepayments.com/agadmin/api/emailSender/post',data).then(response=>{
    //     console.log(response);
    // })
  };

  clickhandler = () => {
    this.flag = this.flag + 1;
    if (this.flag % 2 === 0) {
      this.setState({
        i_agree: false,
      });
    } else {
      this.setState({
        i_agree: true,
      });
    }
  };
  handleEmail = () => {
    if (
      emailValidation(this.state.emailid.trim()) &&
      this.state.emailid.length < 65
    ) {
      let sp = this.state.emailid.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtEmail").classList.add("is-invalid");
        this.setState({ emailError: true });
        return false;
      } else {
        document.getElementById("txtEmail").classList.remove("is-invalid");
        this.setState({ emailError: false });
        return true;
      }
    } else {
      document.getElementById("txtEmail").classList.add("is-invalid");
      this.setState({ emailError: true });
      return false;
    }
  };
  handleFullName = () => {
    let reg = /^[a-zA-Z\-_.'\s]{1,50}$/;
    if (!reg.test(this.state.name.trim())) {
      this.setState({ firstNameError: true });
      document.getElementById("txtFirstName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ firstNameError: false });
      document.getElementById("txtFirstName").classList.remove("is-invalid");
      return true;
    }
  };
  handleMobileNumber = () => {
    const contactRe = /^[6-9]{1}[0-9]{9}$/;
    const ind = this.state.phone.slice(0, 2);
    const phone = this.state.phone.slice(2, 12);
    if (ind === "91") {
      console.log("ind ", ind, " ", phone);
      if (!contactRe.test(phone) || !phone.trim()) {
        this.setState({ mobileNumberError: true });
        document.getElementById("txtMobile").classList.add("is-invalid");
        return false;
      } else {
        this.setState({ mobileNumberError: false });
        document.getElementById("txtMobile").classList.remove("is-invalid");
        return true;
      }
    }
  };

  handleIndustry = () => {
    if (!this.state.industrytype) {
      this.setState({ industryTypeError: true });
      document.getElementById("txtIndustryType3").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ industryTypeError: false });
      document
        .getElementById("txtIndustryType3")
        .classList.remove("is-invalid");
      return true;
    }
  };
  render() {
    var attchedClasses1 = [
      "dv-Registration-content",
      "Open",
      "contactForm-height",
    ];

    return (
      <>
        <div className="blueback"></div>
        <section className={attchedClasses1.join(" ")}>
          <form>
            <div className="dv-registration-form dv-form pt-5 form-padding">
              <div className="form-group">
                <div className="sphd">
                  <h1 className="section-heading border-heading">Contact Us</h1>
                </div>

                <label htmlFor="txtFirstName">
                  Full Name <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-options"
                  id="txtFirstName"
                  placeholder="Enter Name"
                  value={this.state.name}
                  onChange={(event) =>
                    this.setState({ name: event.target.value })
                  }
                  onBlur={this.handleFullName}
                  required
                />
                {this.state.firstNameError && this.state.name === "" ? (
                  <small style={{ color: "red" }}>
                    Please enter your name.
                  </small>
                ) : (
                  this.state.firstNameError && (
                    <small style={{ color: "red" }}>Invalid name</small>
                  )
                )}
              </div>
              <div className="form-group">
                <label htmlFor="txtEmail">
                  Email Address <span className="req">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-options"
                  id="txtEmail"
                  placeholder="Enter Email Address"
                  value={this.state.emailid}
                  onChange={(event) =>
                    this.setState({ emailid: event.target.value })
                  }
                  onBlur={this.handleEmail}
                  required
                />
                {this.state.emailError && this.state.emailid === "" ? (
                  <small style={{ color: "red" }}>
                    Please enter your email.
                  </small>
                ) : (
                  this.state.emailError && (
                    <small style={{ color: "red" }}>
                      Invalid email address.
                    </small>
                  )
                )}
              </div>
              <div className="mobile_input">
                <label htmlFor="txtMobile">
                  Mobile Number <span className="req">*</span>
                </label>
                {/* <input
                  type="number"
                  className="form-control form-options"
                  id="txtMobile"
                  placeholder="Enter Mobile Number"
                  value={this.state.phone}
                  onChange={(event) =>
                    this.setState({ phone: event.target.value })
                  }
                  onBlur={this.handleMobileNumber}
                  required
                /> */}
                <PhoneInput
                  inputProps={{
                    id: "txtMobile",
                  }}
                  country={this.state.countryCode}
                  value={this.state.phone}
                  onChange={(phone) => this.setState({ phone })}
                  onBlur={this.handleMobileNumber}
                />
                {this.state.mobileNumberError && this.state.phone === "" ? (
                  <small style={{ color: "red" }}>
                    Please enter your contact number.
                  </small>
                ) : (
                  this.state.mobileNumberError && (
                    <small style={{ color: "red" }}>
                      Invalid contact number
                    </small>
                  )
                )}
              </div>
              <div className="form-group mt-4">
                <label htmlFor="txtCompanyName">
                  Industry Type <span className="req">*</span>{" "}
                </label>
                <select
                  type="text"
                  className="form-control form-option1"
                  id="txtIndustryType3"
                  placeholder="Eg. Safexpay"
                  onChange={(event) =>
                    this.setState({ industrytype: event.target.value })
                  }
                  onBlur={this.handleIndustry}
                  required
                >
                  <option value="select" selected="true" disabled="disabled">
                    Select
                  </option>
                  <option value="airlines">Airlines</option>
                  <option value="b2b">B2B</option>
                  <option value="donation">Donation</option>
                  <option value="ecommerce">Ecommerce</option>
                  <option value="education">Education</option>
                  <option value="financialservices">Financial Services</option>
                  <option value="hospitality">Hospitality</option>
                  <option value="travel">Travel</option>
                  <option value="utilities">Utilities</option>
                  <option value="other">other</option>
                </select>
                {this.state.industryTypeError && (
                  <small style={{ color: "red" }}>
                    Please choose industry type.
                  </small>
                )}
              </div>
              <div className="form-group form-check text-center my-4">
                <input
                  type="checkbox"
                  className="form-check-input checkbox-margin"
                  id="chkAgreeTC3"
                  onClick={this.clickhandler}
                />
                <label className="form-check-label" htmlFor="chkAgreeTC">
                  I agree to be contacted on the mobile number and email id
                  provided{" "}
                </label>
                {this.state.isAgreeError && (
                  <p className="alert-danger" style={{ color: "#fff" }}>
                    Please accept agreement.
                  </p>
                )}
              </div>
              <h6 className="confmsg111" id="confmsg1">
                Thank you, your message has been sent successfully.
              </h6>
              <div className="text-center">
                <button
                  className="submitbtn1"
                  id="submitbtn4"
                  onClick={this.postdatahandler}
                >
                  Submit
                </button>
              </div>
              <div className="text-center myspin1" id="spinner1">
                <button className="submitbtn1">
                  Loading <span className="fa fa-refresh fa-spin"></span>
                </button>
              </div>
            </div>
          </form>
        </section>
      </>
    );
  }
}

export default DemoContact;
